module.exports = __webpack_public_path__ + "img/square-m.ee5f67e3.svg";